var map = {
	"./css/index.css": "a2f0",
	"./fonts/Montserrat-VariableFont_wght.ttf": "fc83",
	"./images/BCorpLogoBlack.svg": "c3f4",
	"./images/Bean-1.svg": "50a7",
	"./images/Bean-2.svg": "7d0d",
	"./images/Bean-3.svg": "fd41",
	"./images/Bean-4.svg": "bf45",
	"./images/Bean-5.svg": "4cd3",
	"./images/BirdFriendlyLogoBlack.svg": "38aa",
	"./images/FairTradeFederationLogoBlack.svg": "a6bd",
	"./images/USDAOrganicLogoBlack.svg": "01d1",
	"./images/about00.png": "3385",
	"./images/about01.png": "289f",
	"./images/about02.png": "88f2",
	"./images/about03.png": "2a41",
	"./images/about04.png": "eb29",
	"./images/about05.png": "7e8f",
	"./images/deans-beans-logo_350x.webp": "2232",
	"./images/footer-bird-friendly.png": "8fa8",
	"./images/footer-certified-b-corporation.png": "db3e",
	"./images/footer-fair-trade.png": "bbcf",
	"./images/footer-usda-organic.png": "c16e",
	"./images/mission-statement-desktop.svg": "7fb1",
	"./images/mission-statement-mobile.svg": "3b4f",
	"./logo.png": "cf05",
	"./scripts/paymentform": "6a25",
	"./scripts/paymentform.js": "6a25",
	"./styles/mysqpaymentform.css": "99cb",
	"./zzlogo.png": "bb3b",
	"./zzzlogo.png": "b83d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";